import Colors from "assets/Colors";
import SorterDoubleArrow from "components/icons/SorterDoubleArrow";
import SorterUpArrow from "components/icons/SorterUpArrow";
import SorterDownArrow from "components/icons/SorterDownArrow ";
import Loading from "../loading";
import s from "./styles";
import NoDataPlaceHolder from "../NoDataPlaceHolder";

function ArticleRow({ rows: columns, line = true }) {
  return (
    <>
      {columns &&
        columns.map((r, i) => (
          <s.TableCell key={i}>
            {columns.length - 1 === i ? <b> {r}</b> : r}
          </s.TableCell>
        ))}
      {line && <s.Line columns={columns.length} />}
    </>
  );
}

function getSortingArrow(sorting, c) {
  let columnArrow = null;
  if (c.sortable) {
    columnArrow = <SorterDoubleArrow />;
    if (c.columnId === sorting.columnId) {
      if (sorting.order === 1) {
        columnArrow = <SorterUpArrow />;
      } else if (sorting.order === -1) {
        columnArrow = <SorterDownArrow />;
      }
    }
  }
  return columnArrow;
}

function TopProducts({
  items,
  title,
  columns = [],
  tableStyle,
  sorting,
  changeSorting,
  loading,
}) {
  return (
    <s.Container>
      <s.Title>{title}</s.Title>
      {loading ? (
        <Loading height="259px" size="middle" />
      ) : (
        <div
          style={{
            overflowX: "auto",
          }}
        >
          <s.TableContainer style={tableStyle}>
            {columns.map((c, i) => {
              const columnArrow = getSortingArrow(sorting, c);
              return (
                <s.TableCell
                  key={i}
                  onClick={() => {
                    c.sortable
                      ? changeSorting(c.columnId, sorting.order === 1 ? -1 : 1)
                      : null;
                  }}
                  style={{ background: Colors.BG_MENU }}
                >
                  <s.InsideCell
                    style={{
                      gap: "5px",
                    }}
                  >
                    <div>
                      {columns.length - 1 === i ? <b> {c.title}</b> : c.title}
                    </div>
                    {columnArrow}
                  </s.InsideCell>
                </s.TableCell>
              );
            })}
            {items &&
              items.map((item, i) => (
                <ArticleRow key={i} rows={item} line={i !== items.length - 1} />
              ))}
          </s.TableContainer>
          {(!items || items.length === 0) && <NoDataPlaceHolder />}
        </div>
      )}
    </s.Container>
  );
}

export default TopProducts;
